import { useMemo } from 'react'
import Slider from 'ui/src/components/controls/slider'
import { Colors } from './style'

type Props = {
    className?: string
    hsv: number[]
    onChange?: (hue: number) => void
}

const ColorPickerHue = ({ className, hsv, onChange }: Props) => {
    const hue = useMemo(() => hsv[0] / 360, [hsv[0]])

    const onSliderChange = (value: number) => {
        onChange?.(Math.round(value * 360))
    }

    return (
        <Slider
            className={className}
            color="transparent"
            layout="bar"
            size="mini"
            value={hue}
            onChange={onSliderChange}
        >
            <Colors />
        </Slider>
    )
}

export default ColorPickerHue
